// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { zIndexes, spacing } from 'frontend_core/dist/styles/variables'
import Close from 'components/atoms/Close'

const ModalBg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  z-index: ${zIndexes.topmost};
  visibility: hidden;
  transition: all 0.3s;
  ${({ isActive }) =>
    isActive &&
    css`
      opacity: 1;
      visibility: visible;
    `};
`

const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

const ModalContent = styled.div`
  padding: ${spacing.medium_3}px 0;
  ${mediaMin.phone`
    padding: ${spacing.huge_2}px 0;
  `};
`

const ModalInner = styled.div`
  padding: 0 ${spacing.medium}px;
`

const ModalContentInner = styled.div`
  position: relative;
  width: 100%;
  max-width: 768px;
  padding: ${spacing.large}px ${spacing.medium}px ${spacing.medium}px;
  margin: 0 auto;
  background-color: ${Colors.white};
  ${mediaMin.phone`
    padding: ${spacing.huge}px ${spacing.medium}px;
  `};
`

const CloseWrapper = styled.span`
  position: absolute;
  display: inline-block;
  top: 16px;
  right: 16px;
`

const ChildrenWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  ${({ large }) =>
    large &&
    css`
      max-width: 600px;
    `};
`

export type PropTypes = {
  onClickClose: Function,
  isActive?: boolean,
  children?: ?any,
  large?: boolean,
}

export default (props: PropTypes) => (
  <ModalBg isActive={props.isActive}>
    <ModalContainer>
      <ModalInner>
        <ModalContent>
          <ModalContentInner>
            <CloseWrapper>
              <Close onClick={props.onClickClose} />
            </CloseWrapper>
            <ChildrenWrapper large={props.large}>
              {props.children}
            </ChildrenWrapper>
          </ModalContentInner>
        </ModalContent>
      </ModalInner>
    </ModalContainer>
  </ModalBg>
)



// WEBPACK FOOTER //
// ./src/components/molecules/Modal/index.jsx